/**
 * Confirmação da limpeza do cache compartilhado. O item do menu fica no Shell (dentro do
 * dropdown); o modal fica fora, para continuar na tela quando o menu fecha.
 */
import { Button, Group, Modal, Text } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { apiPost } from '../api/cliente';

export function DialogoLimparCache({
  aberto,
  onFechar,
}: {
  aberto: boolean;
  onFechar: () => void;
}) {
  const [limpando, setLimpando] = useState(false);
  const [limpo, setLimpo] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);
  const consultas = useQueryClient();

  function fechar() {
    if (limpando) return;
    setLimpo(false);
    setAviso(null);
    onFechar();
  }

  async function limpar() {
    setLimpando(true);
    setAviso(null);
    try {
      await apiPost<{ ok: boolean }>('/cache/limpar', {});
      await consultas.invalidateQueries();
      setLimpo(true);
    } catch (erro) {
      setAviso(erro instanceof Error ? erro.message : 'Não foi possível limpar o cache.');
    } finally {
      setLimpando(false);
    }
  }

  return (
    <Modal opened={aberto} onClose={fechar} title="Limpar cache" centered>
      {limpo ? (
        <>
          <Text size="sm">Cache limpo. As páginas abertas nesta tela serão recalculadas.</Text>
          <Group justify="flex-end" mt="md">
            <Button onClick={fechar}>Fechar</Button>
          </Group>
        </>
      ) : (
        <>
          <Text size="sm">
            Isso apaga o cache de todo mundo. A próxima consulta de cada página recalcula os dados.
          </Text>
          {aviso && (
            <Text size="sm" c="red" mt="sm">
              {aviso}
            </Text>
          )}
          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={fechar} disabled={limpando}>
              Cancelar
            </Button>
            <Button color="red" onClick={() => void limpar()} loading={limpando}>
              Limpar cache
            </Button>
          </Group>
        </>
      )}
    </Modal>
  );
}
